import { render, staticRenderFns } from "./profit-statistics-copy.vue?vue&type=template&id=ab204766&scoped=true&"
import script from "./profit-statistics-copy.vue?vue&type=script&lang=js&"
export * from "./profit-statistics-copy.vue?vue&type=script&lang=js&"
import style0 from "./profit-statistics-copy.vue?vue&type=style&index=0&id=ab204766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab204766",
  null
  
)

export default component.exports